import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"basic\"><a href=\"#basic\"></a> Basic </h1><div class=\"py-5\"> Use <code>.rotate</code> class on a button and <code>.rotate-{degree}</code> class on a icon to rotate it to following <code>degree</code> options: </div><ul class=\"pt-3 pb-5\"><li class=\"py-2\"><code>90</code> - for classes that rotates to <code>90 deg</code></li><li class=\"py-2\"><code>180</code> - for classes that rotates to <code>180 deg</code></li><li class=\"py-2\"><code>270</code> - for classes that rotates to <code>270 deg</code></li><li class=\"py-2\"><code>n90</code> - for classes that rotates to negative <code>-90 deg</code></li><li class=\"py-2\"><code>n180</code> - for classes that rotates to negative <code>-180 deg</code></li><li class=\"py-2\"><code>n270</code> - for classes that rotates to negative <code>-270 deg</code></li></ul>", 3)
const _hoisted_5 = { class: "py-5" }
const _hoisted_6 = { class: "rounded border p-10 pb-5" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-primary me-5 mb-5"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Default ")
const _hoisted_9 = { class: "svg-icon svg-icon-2 ms-3" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-primary active me-5 mb-5 rotate"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 90 deg ")
const _hoisted_12 = { class: "svg-icon svg-icon-2 rotate-90 ms-3" }
const _hoisted_13 = {
  type: "button",
  class: "btn btn-primary rotate active me-5 mb-5"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 180 deg ")
const _hoisted_15 = { class: "svg-icon svg-icon-2 rotate-180 ms-3" }
const _hoisted_16 = {
  type: "button",
  class: "btn btn-primary rotate active me-5 mb-5"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 270 deg ")
const _hoisted_18 = { class: "svg-icon svg-icon-2 rotate-270 ms-3" }
const _hoisted_19 = {
  type: "button",
  class: "btn btn-primary rotate active me-5 mb-5"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" -90 deg ")
const _hoisted_21 = { class: "svg-icon svg-icon-2 rotate-n90 ms-3" }
const _hoisted_22 = {
  type: "button",
  class: "btn btn-primary rotate active me-5 mb-5"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" -180 deg ")
const _hoisted_24 = { class: "svg-icon svg-icon-2 rotate-n180 ms-3" }
const _hoisted_25 = {
  type: "button",
  class: "btn btn-primary rotate active me-5 mb-5"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" -270 deg ")
const _hoisted_27 = { class: "svg-icon svg-icon-2 rotate-n270 ms-3" }
const _hoisted_28 = { class: "py-5" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`<button type="button" class="btn btn-primary">
          Default <svg class="svg-icon-2"></svg>
        </button>

        <button type="button" class="btn btn-primary rotate">
          90 deg <span class="svg-icon-2 rotate-90"><svg></svg></span>
        </button>

        <button type="button" class="btn btn-primary rotate">
          180 deg <span class="svg-icon-2 rotate-180"><svg></svg></span>
        </button>

        <button type="button" class="btn btn-primary rotate">
          270 deg <span class="svg-icon-2 rotate-270"><svg></svg></span>
        </button>

        <button type="button" class="btn btn-primary rotate">
          -90 deg <span class="svg-icon-2 rotate-n90"><svg></svg></span>
        </button>

        <button type="button" class="btn btn-primary rotate">
          -180 deg <span class="svg-icon-2 rotate-n180"><svg></svg></span>
        </button>

        <button type="button" class="btn btn-primary rotate">
          -270 deg
          <span class="svg-icon-2 rotate-n270"><svg></svg></span></button
        >`))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("button", _hoisted_7, [
          _hoisted_8,
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", _hoisted_12, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_13, [
          _hoisted_14,
          _createVNode("span", _hoisted_15, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_16, [
          _hoisted_17,
          _createVNode("span", _hoisted_18, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_19, [
          _hoisted_20,
          _createVNode("span", _hoisted_21, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_22, [
          _hoisted_23,
          _createVNode("span", _hoisted_24, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ]),
        _createVNode("button", _hoisted_25, [
          _hoisted_26,
          _createVNode("span", _hoisted_27, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-to-right.svg" })
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_28, [
      _createVNode(_component_CodeHighlighter, {
        lang: "html",
        fieldHeight: 400
      }, {
        default: _withCtx(() => [
          _hoisted_29
        ]),
        _: 1
      })
    ])
  ]))
}